import {disablePageScroll, enablePageScroll} from '@fluejs/noscroll';
import debounce from "../helpers/debounce";

class Nav {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.navToggle = self.elem.querySelector('[data-nav-toggle]');
        self.nav = self.elem.querySelector('[data-nav]');
        self.onEscape = self.onEscape.bind(self);
        self.onTouchStart = self.onTouchStart.bind(self);
        self.onTouchEnd = self.onTouchEnd.bind(self);
        self.touchStartX = 0;
        self.touchEndX = 0;
        self.onTransitionEnd = self.onTransitionEnd.bind(self);
        self.navLinks = [...self.elem.querySelectorAll('[data-nav-link]')];
        self.isOpen = false;
    }

    init() {
        let self = this;

        self.navToggle.addEventListener('click', evt => {
            evt.preventDefault();

            if(self.isOpen) {
                self.close();
            } else {
                self.open();
            }
        });

        if(self.nav.classList.contains('is-open')) {
            self.open();
        }

        const scrollDebounce = debounce(function () {
            if(window.scrollY > 0) {
                self.nav.classList.add('is-off-canvas');
            } else {
                self.nav.classList.remove('is-off-canvas');
            }
        });

        window.addEventListener('scroll', function () {
            scrollDebounce();
        }, false);

        self.navLinks.map(link => {
            link.addEventListener('click', evt => {
                const href = link.getAttribute('href');
                if (!href) return;

                const url = new URL(href, location.origin);

                const isSamePageAnchor =
                    url.origin === location.origin &&
                    url.pathname === location.pathname &&
                    url.hash &&
                    url.hash.length > 1;

                if (isSamePageAnchor) {
                    self.close(true);
                }
            });
        });
    }

    open() {
        let self = this;

        // Enable transition
        self.enableTransition();
        
        // Add is-active class to hamburger
        self.navToggle.classList.add('is-active');

        // Set aria-expanded attribute to true
        self.navToggle.setAttribute('aria-expanded', true);

        // Open the nav
        self.nav.classList.add('is-open');

        // Disable scrolling on body
        disablePageScroll();

        // Enable event listeners
        self.addEventListeners();

        self.isOpen = true;
    }

    close() {
        let self = this;

        self.nav.addEventListener('transitionend', self.onTransitionEnd);

        // Remove is-open class from nav
        self.nav.classList.remove('is-open');

        // Remove is-active class from hamburger
        self.navToggle.classList.remove('is-active');

        // Set aria-expanded attribute to false
        self.navToggle.setAttribute('aria-expanded', false);

        // Enable scrolling on body
        enablePageScroll();

        // Disable event listeners
        self.removeEventListeners();

        self.isOpen = false;
    }

    enableTransition() {
        let self = this;

        self.nav.classList.add('has-transition');
    }

    disableTransition() {
        let self = this;

        self.nav.classList.remove('has-transition');
    }

    addEventListeners() {
        let self = this;

        // Start listening for escape key press
        document.addEventListener('keydown', self.onEscape);
        self.nav.addEventListener('touchstart', self.onTouchStart);
        self.nav.addEventListener('touchend', self.onTouchEnd);
    }

    removeEventListeners() {
        let self = this;

        // Stop listening for escape key press
        document.removeEventListener('keydown', self.onEscape);
        self.nav.removeEventListener('touchstart', self.onTouchStart);
        self.nav.removeEventListener('touchend', self.onTouchEnd);
    }

    onEscape(evt) {
        let self = this;

        if (evt.key === "Escape") {
            self.close();
        }
    }

    onTouchStart(evt) {
        let self = this;

        self.touchStartX = evt.changedTouches[0].screenX;
    }

    onTouchEnd(evt) {
        let self = this;

        self.touchEndX = evt.changedTouches[0].screenX;
        
        const swipeDistance = self.touchEndX - self.touchStartX;
        const swipeThreshold = 100; // minimum distance to be considered a swipe

        // Swiping right to left (close gesture)
        if (swipeDistance < -swipeThreshold) {
            self.close();
        }
    }

    onTransitionEnd() {
        let self = this;

        self.disableTransition();
        self.nav.removeEventListener('transitionend', self.onTransitionEnd);
    }
}

export default Nav;